import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { getSignerSubmitedDetails } from "../../../store/actions/editorActions";
import { DataFormatter } from "../../ui/dataFormatter";

let style = Object.assign({}, global);

const SignerDetailsModal = props => {
  const dispatch = useDispatch();

  const [submitatedDetails, setSubmitatedDetails] = useState();
  const [leftColumnItems, setLeftColumnItems] = useState();
  const [rightColumnItems, setRightColumnItems] = useState();

  const closeModal = () => {
    props.setShowModal(!props.showModal);
  };

  useEffect(() => {
    dispatch(getSignerSubmitedDetails(props.activeSignatureId)).then(r => {
      let newValue = { ...r.data.data.signer_details };

      setSubmitatedDetails({
        ...r.data.data,
        ["signer_details"]: newValue ? newValue : r.data.data.signer_details,
      });
    });
  }, []);

  useEffect(() => {
    if (submitatedDetails?.signer_details) {
      // STEP 1: Collect & flatten all fields
      const flattenedFields = [];

      if (submitatedDetails?.signer_details) {
        Object.entries(submitatedDetails.signer_details).forEach(([key, value]) => {
          flattenedFields.push({ key, value });
        });
      }

      if (submitatedDetails?.signed_on) {
        const date = new Date(submitatedDetails.signed_on * 1000);
        flattenedFields.push({
          key: "Signed On",
          value: date.toLocaleString("en-GB", {
            weekday: "short",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }),
        });
      }

      if (submitatedDetails?.signature_method) {
        flattenedFields.push({
          key: "Signature Method",
          value: submitatedDetails.signature_method,
        });
      }

      if (submitatedDetails?.ip) {
        flattenedFields.push({
          key: "IP Address",
          value: submitatedDetails.ip,
        });
      }

      if (submitatedDetails?.system) {
        Object.entries(submitatedDetails.system).forEach(([key, value]) => {
          flattenedFields.push({ key: key, value });
        });
      }

      if (submitatedDetails?.location) {
        Object.entries(submitatedDetails.location).forEach(([key, value]) => {
          flattenedFields.push({ key: key, value });
        });
      }

      // STEP 2: Alternate fields into two columns
      const lColumnItems = [];
      const rColumnItems = [];

      flattenedFields.forEach(({ key, value }, index) => {
        const item =
          key === "Signed On" ? (
            <li key={key + index} className={style["mb-4"]}>
              <h6 className={cx(style["fw-7"], style["mb-2"])}>Signed On</h6>
              <div className={cx(style["pb-1"], style["border-bottom"])}>
                <DataFormatter
                  type="date-time"
                  slug="signed_on"
                  data={submitatedDetails}
                  format="default"
                  showBlank={true}
                />
              </div>
            </li>
          ) : (
            <li key={key + index} className={style["mb-4"]}>
              <h6 className={cx(style["fw-7"], style["mb-2"], style["text-capitalize"])}>{key}</h6>
              <div className={cx(style["pb-1"], style["border-bottom"])}>{value}</div>
            </li>
          );

        (index % 2 === 0 ? lColumnItems : rColumnItems).push(item);
      });

      setLeftColumnItems(lColumnItems);
      setRightColumnItems(rColumnItems);
    }
  }, [submitatedDetails]);

  return (
    <>
      <div className={cx(style["d-flex"], style["align-items-center"])}>
        <h4 className={cx(style["fw-7"], style["mb-4"])}>Submitted Details</h4>
        <span className={cx(style["cross-modal"], style["rounded"])} onClick={closeModal}>
          <Icon icon="ui-close" />
        </span>
      </div>
      {/* Loader */}
      {!submitatedDetails && (
        <>
          <ul className={cx(style["column-2"])}>
            {[...Array(5)].map((_, i) => (
              <li
                key={i}
                className={cx(
                  style["mb-4"],
                  style["skeleton-loader-area"],
                  style["flex-column"],
                  style["align-items-start"]
                )}>
                <span className={cx(style["loader-item"], style["w-75"], style["mb-2"])}></span>
                <span className={cx(style["loader-item"], style["w-100"])}></span>
              </li>
            ))}
          </ul>
        </>
      )}
      {/* Submited details form */}
      {submitatedDetails && (
        <div className={cx(style["customScroll"], style["scroll-Y"])} style={{ "user-select": "text" }}>
          <div className={cx(style["d-flex"], style["justify-content-between"], style["submited-content"])}>
            <ul className={style["left"]}>{leftColumnItems}</ul>
            <ul className={style["right"]}>{rightColumnItems}</ul>
          </div>
        </div>
      )}
    </>
  );
};
//Props type validation
SignerDetailsModal.propTypes = {
  activeSignatureId: PropTypes.string,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
};

export default SignerDetailsModal;
